module.exports = __webpack_public_path__ + "img/35.e95830f3.png";